import { SaveRole, GetRole, GetAdminUser, SaveAdminUser } from '@/api/role'
export default {
  state: {},
  actions: {
    SaveRole ({ commit }, payload) {
      return new Promise(resolve => {
        SaveRole(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetRole ({ commit }, payload) {
      return new Promise(resolve => {
        GetRole(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetAdminUser ({ commit }, payload) {
      return new Promise(resolve => {
        GetAdminUser(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveAdminUser ({ commit }, payload) {
      return new Promise(resolve => {
        SaveAdminUser(payload).then(res => {
          resolve(res.data)
        })
      })
    }

  },
  getters: {},
  mutations: {}
}
